module.exports = "/_next/static/images/product-hunt-l@3x-124224b503df5698713ff364c61e03af.png";